if (!customElements.get('cro-collection-rail')) {
  customElements.define('cro-collection-rail', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.resizeObserver?.disconnect();
      this.lifecycle = new AbortController();
      const track = this.querySelector('[data-cro-rail-track]');
      if (!track) return;
      const updateLayout = () => {
        const width = track.clientWidth;
        const count = track.children.length;
        if (!width || !count) return;
        const style = getComputedStyle(track);
        const gap = parseFloat(style.columnGap) || 0;
        const preferred = (parseFloat(style.getPropertyValue('--cro-rail-circle-size')) || 64) + 24;
        let itemWidth = Math.min(preferred, width);
        if (count > 1 && count * preferred + (count - 1) * gap > width) {
          const configured = parseInt(style.getPropertyValue('--cro-rail-min-items'), 10) || 0;
          const minimum = configured > 0 ? Math.max(3, Math.min(5, configured)) : 1;
          const fitting = Math.floor((width + gap) / (preferred + gap) - 0.5);
          const visible = Math.min(count - 1, Math.max(minimum, fitting));
          // Fit complete cards plus half a card into the real content viewport.
          itemWidth = (width - visible * gap) / (visible + 0.5);
        }
        const value = `${Math.max(1, itemWidth)}px`;
        if (track.style.getPropertyValue('--cro-rail-item-width') !== value) {
          track.style.setProperty('--cro-rail-item-width', value);
        }
      };
      updateLayout();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(updateLayout);
        this.resizeObserver.observe(track);
      }
      window.addEventListener('resize', updateLayout, { signal: this.lifecycle.signal });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-cro-rail-item]');
        if (!item || !track.contains(item)) return;
        const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        const offset = Math.abs(item.offsetLeft - track.firstElementChild.offsetLeft);
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        track.scrollTo({ left: direction * Math.min(maximum, offset), behavior: 'instant' });
      }, { signal: this.lifecycle.signal });
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
